module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10032.2e27fafe.jpg";